import React, { useState } from "react";
import { ChevronDoubleDownIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

const CustomCategoryCardsWithCategory = ({
  image,
  title,
  category,
  link,
  subCategory,
}) => {
  const { i18n } = useTranslation();

  const [isHovered, setIsHovered] = useState(false);
  const title1 = i18n.language === "ar" ? title?.ar : title?.en;

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <a
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="flex flex-col items-center justify-between w-full h-full gap-3 text-center"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className=" h-[30px] w-full ">
        <div className="relative flex justify-center ">
          <ChevronDoubleDownIcon className="w-6 h-6 md:w-7 md:h-7 text-black absolute top-[0px] opacity-0 group-hover:opacity-100 duration-300 " />
        </div>
      </div>
      <img
        src={image}
        alt="image"
        loading="lazy"
        className=" lg:h-[180px] h-[100px] object-contain"
      />
      <div
        className={`w-full px-1 inline-block duration-300 ${
          isHovered ? "bg-custom-yellow" : "bg-custom-yellow"
        }`}
      >
        <h2
          className={`text-sm font-medium lg:text-base py-2 duration-300 ${
            isHovered ? "text-black" : "text-black"
          }`}
        >
          {category} ({subCategory})
        </h2>
      </div>
    </a>
  );
};

export default CustomCategoryCardsWithCategory;
